import { type UseModalState } from "@clipboard-health/ui-components";
import { FullScreenDialog } from "@src/appV2/lib/Dialogs/FullScreen/Dialog";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { useRef } from "react";

import { REFERENCE_FORM_ID } from "../utils/formHelpers";
import { ReferenceForm } from "./ReferenceForm";

interface AddReferenceDialogProps {
  modalState: UseModalState;
  count: number;
}

export function AddReferenceDialog(props: AddReferenceDialogProps) {
  const { modalState, count } = props;
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <FullScreenDialog skipTopSafeAreaPadding variant="tertiary" modalState={modalState}>
      <StickyScrollPageHeader
        hideBackButton
        title="Add Reference"
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
        navigateBack={modalState.closeModal}
        rightAction={
          <IconButton
            iconType="close"
            aria-label="Close"
            variant="outlined"
            size="medium"
            onClick={modalState.closeModal}
          />
        }
      />
      <ReferenceForm
        initialFocusFirstField
        scrollRef={scrollRef}
        id={REFERENCE_FORM_ID}
        count={count}
        onSuccess={() => {
          modalState.closeModal();
        }}
      />
    </FullScreenDialog>
  );
}
